import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

function Login() {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { loginWithGoogle } = useAuth();

  async function handleGoogleLogin() {
    setError('');
    setLoading(true);

    try {
      await loginWithGoogle();
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Welcome to Pokédex</h2>
        <p className="login-subtitle">Sign in with your Azra Games account</p>

        {error && <div className="login-error">{error}</div>}

        <button
          onClick={handleGoogleLogin}
          className="google-button"
          disabled={loading}
        >
          {loading ? 'Signing in...' : 'Continue with Google'}
        </button>
      </div>
    </div>
  );
}

export default Login;
